import { ContainerType } from "../../utils/Enum/InventoryExceptionType";
import ICMAxios from "../ICMAxios";
const ContainerizedDetailService = {
 validateContainerizedDetail : (request: any) => 
  ICMAxios.post(`v1/ContainerizedDetail/validate-containerized-detail`, request),

  getTrackingInfoByInventoryRequest :(inventoryId:  number) =>
        ICMAxios.get(`v1/ContainerizedDetail/inventory/${inventoryId}/tracking-info`),
    
    getTagContainerizedDetailAsync: (data: any) =>
        ICMAxios.post(`v1/ContainerizedDetail/containerized-detail`, data),
    getExceptionDetails: (inventoryId?: number) => {
        let url = `v1/ContainerizedDetail/exceptions-detail`;
        if (inventoryId && inventoryId > 0) {
            url += `/${inventoryId}`;
        }
        return ICMAxios.get(url);
    },
    getExceptionsByField :(inventoryId:  number, containerId: number, containerType: ContainerType, selectedValue:string|null) =>{
        const request= {
            inventoryId,
            containerId,
            containerType,
            selectedValue
        };
        return ICMAxios.post(`v1/ContainerizedDetail/exception-field`, request)
    },
    acceptException :(request:any) =>{
        return ICMAxios.post(`v1/ContainerizedDetail/accept-exception`, request)
    },
    updateContainerizedDetail : (request: any) => 
    ICMAxios.put(`v1/ContainerizedDetail/update-containerized-detail`, request),

     getTagsWithExceptionsAsync: (data: any) =>
        ICMAxios.post(`v1/ContainerizedDetail/tags-with-exceptions`, data),

     exportContainerizedDetails: async (inventoryId: number) => {
       const response = await ICMAxios.get("v1/ContainerizedDetail/export-containerized-details", {
  params: { inventoryId }
});
       return response?.data;
     }
}

export default ContainerizedDetailService;